import { TourBase } from "../TourBase/TourBase";
import React, { useMemo } from "react";
import { ITourStepDefinition } from "../TourBase/TourStepFooter";
import { Box, Stack } from "@chakra-ui/react";
import { PromptOptionButton } from "components";
import { faPlay, faUsers } from "@fortawesome/pro-regular-svg-icons";
import { getToolToursLinks, ToolTours } from "constants/tool-tours-links";

interface IProps {
  tourId: ToolTours;
}

export const ToolTour: React.FC<IProps> = ({ tourId }) => {
  const toolToursLinks = getToolToursLinks();

  const steps = useMemo(() => {
    const steps: ITourStepDefinition[] = [
      {
        content: (
          <Box width={"500px"}>
            <Box fontSize={"xl"} fontWeight={600} mb={2}>
              Help &amp; support
            </Box>
            <Stack>
              <PromptOptionButton
                title="Book a free webinar"
                icon={faUsers}
                color="teal"
                onClick={() =>
                  window.open(
                    toolToursLinks[tourId].webinarLink,
                    "_blank",
                    "noopener,noreferrer"
                  )
                }
              />
              <PromptOptionButton
                title="Watch the setup guide"
                icon={faPlay}
                color="teal"
                onClick={() =>
                  window.open(
                    toolToursLinks[tourId].guideLink,
                    "_blank",
                    "noopener,noreferrer"
                  )
                }
              />
            </Stack>
          </Box>
        ),
      },
    ];

    return steps;
  }, [toolToursLinks, tourId]);

  return <TourBase tourId={tourId} steps={steps} showCloseButton={true} />;
};
